<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Asignar Director",
            items: [
                {
                text: "Utility",
                href: "/"
                },
                {
                text: "Starter Page",
                active: true
                }
            ],
            colegios:[],
            colegio:'',
            users:[],
            datos:{}
        };
    },
    methods:{
        actualizar(){
            axios.get('/api/get_colegios_director').then(res=>{
                this.colegios = res.data.colegio_director;
            });
            
        },
        editar(colegio){
            this.colegio=colegio.colegio['nombre'];
            if(colegio.director!=null){
                this.datos.director_nuevo = colegio.director['id'];
                this.datos.director_antiguo = colegio.director['id'];
            }else{
                this.datos.director_nuevo =''
            }
            this.datos.colegio = colegio.colegio['id'];
            axios.get('/api/get_personas_colegio/'+colegio.colegio['id']).then(res=>{
                this.users = res.data.users;
            });
            this.$refs['my-modal'].show();
        },
        asignar(){
            //console.log(this.datos);
            axios.post('/api/asignar_director',this.datos).then(res=>{
                if (res.data.estado) {
                    Swal.fire({
                        title: "Se ha asignado el Director correctamente", 
                        //text: "Debe tomar conocimiento sobre los Documentos Institucionales y Reglamentos",
                        icon: "success",
                        confirmButtonColor: "#f1b44c",
                        confirmButtonText: "Aceptar"
                    });
                }
                this.actualizar();
            });
        }
    },
    created(){
        this.actualizar();
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <b-button class="float-right" variant="primary" href="/app/agregar/usuarios">Usuarios</b-button>
                            </div>
                            <div class="offset-md-2 col-md-8 mt-3">
                                <div class="table-responsive">
                                    <table class="table table-bordered table-hover mb-0">
                                        <thead>
                                            <tr>
                                                <th>Nº</th>
                                                <th>Colegio</th>
                                                <th>Director</th>
                                                <th>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(colegio,index) in colegios" :key="index">
                                                <th scope="row">{{index+1}}</th>
                                                <td>{{colegio['colegio']['nombre']}}</td>
                                                <td v-if="colegio.director!=null">{{colegio['director']['nombre']}} {{colegio['director']['apellidoPaterno']}} {{colegio['director']['apellidoMaterno']}}</td>
                                                <td v-else>No hay director asignado</td>
                                                <td>
                                                    <b-button variant="primary" size="sm" @click="editar(colegio)">Editar</b-button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <b-modal ref="my-modal" title="Asignar Director" cancel-title="Cancelar" ok-title="Asignar" @ok="asignar()">
                                    <div>
                                        <h4>{{colegio}}</h4>
                                    </div>
                                    <div class="ml-3 mt-3">
                                        <b-form-group id="example text" label-cols-sm="12" label-cols-lg="3" label="Director" label-for="text">
                                            <div class="form-group row mb-2">
                                                <div class="col-md-10">
                                                    <select class="custom-select" v-model="datos.director_nuevo">
                                                        <option value="" selected>Seleccione un Usuario</option>
                                                        <option :value="director.id" v-for="director in users" :key="director.id">{{director.nombre}} {{director.apellidoPaterno}} {{director.apellidoMaterno}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </b-form-group>
                                    </div>
                                </b-modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>